import * as React from 'react';
import './HomePage.css';
import HelpModal from './HelpModal';

export default class HomePage extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {helpDisplay: false};
  }

  onShowHelp = () => {
    this.setState({helpDisplay: true})
  };

  onHideHelp = () => {
    this.setState({helpDisplay: false})
  };

  render() {
    return (
      <div className="homepage-box">
        <p>The Historical Land Records Viewer (HLRV) provides online access to more than 19 million images of historical maps, plans, titles, registers and indexes. These records are part of the historical fabric of the founding days of the State of New South Wales.</p>
        <h1>What records can I search in HLRV?</h1>
        <p>HLRV contains a range of records that can be searched and viewed. They are:</p>
        <ul>
          <li><b>Maps:</b> a collection of parish maps and town maps that show how subdivisions and other actions have changed land parcels over time.</li>
          <li><b>Plans:</b> details of plans registered between 1863 and 1995.</li>
          <li><b>Old System Records:</b> information about land registered under the ‘old system’ between 1792 and 1863, including the General Register of Deeds, Old System Registers, Indexes and Primary Application Records.</li>
          <li><b>Old Form Torrens Register and The Purchasers Index:</b> records of Torrens Titles from 1863 to 1961 and the Purchasers Index from 1863 to 1971.</li>
        </ul>
        
        <p>
          The General Register of Deeds and Old Form Torrens Register can be purchased over the counter at NSW Land Registry Services or through an approved Information Broker.
        </p>

        <p>
          For a list of approved Information Brokers, visit <a href="https://nswlrs.com.au/services/record-searches/how-to-find-an-information-broker" target="_blank">www.nswlrs.com.au/services/record-searches/how-to-find-an-information-broker</a>.
        </p>
        
        <p>
          Further information about these collections and how to search can be viewed on <a href="https://nswlrs.com.au/services/record-searches/historical-research" target="_blank">NSW LRS Historical Records Online page</a>.
        </p>
        
        <h1>Tips for searching historical land records</h1>
        <p>Land records and titling is complex in nature. The NSW Land Registry Services search guides provide information on researching land records. Click here to view and download <a href="https://nswlrs.com.au/services/record-searches/historical-research" target="_blank">NSW LRS search guides</a>.</p>
        
        <h2>Search support</h2>
        <p>
          Searches can also be conducted for customers by NSW Land Registry Services for a fee. Time based service fees apply in addition to standard document copy rates. For more information, contact us at <a href="mailto:searchrequests@nswlrs.com.au">searchrequests@nswlrs.com.au</a>
        </p>
        
        <h1>Feedback, suggestions, and enquiries</h1>
        <p>If you have any feedback or general enquiries about HLRV, please <a href="https://nswlrs.com.au/about-us/contact-us" target="_blank">contact us</a>.</p>
        
        <h1>Terms and conditions of use</h1>
        <p>Click here for HLRV site <a onClick={this.onShowHelp}>Support</a> and to view the Terms and Conditions.</p>
        <HelpModal visibility={this.state.helpDisplay} onHideHelp={this.onHideHelp} selectedMenu="3"/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HomePage.tsx